module.exports = __webpack_public_path__ + "static/media/locations.30f7ea11.svg";